import { useState } from 'react';
import { ErrorBoundary } from '../../helpers/errorBoundary'
import Aux from '../hoc/auxiliary'
import DocumentViewer from '../common/documentViewer';
import { SpinnerPage } from '../hoc/spinnerPage';

export const ProductFile = ({
 
    urlWithSas
    // onCitationClicked
}) => {

    const [ fileLoading, setFileLoading] = useState(false)

    // useEffect(() => {

    //     //  if(product && product.previewUrl && !ReactPlayer.canPlay(product.url) && product.resourceFormatId !== 1000){
    //     //   getBlobFromUrl(product);
    //     // }
  
    //         getUrlWithSas()
  
    //   }, [product])

   

    //   const getBlobFromUrl = (res) => {

    //     const apiBaseUrl = `${config.apiUrl}fileupload/download`;
    //     const blob = { Url: res.previewUrl , Name: res.uploadedFileName, IsExternalFile: res.isExternalFile, isPreview: true, isFromPlanner: false  };
    //     setFileLoading(true)
  
  
    //     axios.post(apiBaseUrl, blob, {
    //         headers: authHeader(),
    //         responseType: 'blob' //Force to receive data in a Blob Format
    //     }).then(response => {
            
    //         var blob = new Blob([response.data], {type: response.data.type});
    //         let url = URL.createObjectURL(blob)
    //         // console.log("url", url)
    //         setFile(url)
    //         setFileLoading(false)
            
    //     }).catch(function (error) {
    //         console.log('Looks like there was a problem: \n', error.response.data);
    //         //component.setState({ printingmessage: error.response.data })
    //     });
    // }



    
    //lets make this a switch
    // const url = product.resourceFormatId === 1000 //quizlet
    //     ? product.url
    //     : "https://view.officeapps.live.com/op/embed.aspx?src=" + product.url;

    return(
  
       
                <div className="gpt-message__product--file">
                          
                               {/* {

                                product.resourceFormatId !== 2 && product.isExternalFile
                                ?

                                <ErrorBoundary>
                                <Iframe url={url}
                                id="myId"
                                className="resource-preview__office"
                                display="initial"
                                position="relative"
                                />
                                </ErrorBoundary>


                                : */}

                                <Aux>
                                <SpinnerPage loading={fileLoading}>
                                
                             

                                {
                                urlWithSas
                                ?
                                <ErrorBoundary>
                                <DocumentViewer
                                file={urlWithSas}
                                // listOfResourceTypes={product.listOfResourceTypes}
                                // fullScreenMount={props.fullScreenMount}
                                fullScreenMount={true}
                                showWatermark={false}
                                isFromChat={true}
                                />
                                </ErrorBoundary>
                                :
                                <div></div>
                                }
                                                  
                                </SpinnerPage>


                                </Aux>

                                {/* } */}
                </div>
                    
      
    )


}